<span class="d-block fw-regular mb-3">{{ label }}</span>
@if (supplementaryDeclarant) {
  @if (supplementaryDeclarant) {
    <div class="card form-group">
      <div class="card-body p-4">
        <div class="row mb-3">
          <div class="col d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="EORI number" [includeMargin]="false" [checkForErrors]="true"
                            [(value)]="supplementaryDeclarant.identificationNumber"
                            [editMode]="editMode && declarantEditMode">
              <input class="input-group form-control" [(ngModel)]="supplementaryDeclarant.identificationNumber"
                     required/>
            </app-form-field>
          </div>
          <input [ngModel]="supplementaryDeclarant.supplementaryFilingType" type="hidden">
        </div>
        @if (editMode && declarantEditMode) {
          <div class="row mt-3">
            <div class="col-auto ms-auto">
              <button type="button" class="btn btn-outline-secondary" aria-label="Cancel" (click)="cancel()">Cancel
              </button>
            </div>
            <div class="col-auto">
              <button type="button" class="btn btn-primary" (click)="save()">Save</button>
            </div>
          </div>
        }
        @if (editMode && !declarantEditMode) {
          <button type="button" class="btn btn-tertiary position-absolute end-0 top-0 me-2 mt-2 p-1"
                  (click)="toggleEditMode()">
            <i class="fa fa-fw fa-light fa-pencil"></i>
          </button>
        }
      </div>
    </div>
  }
} @else {
  <span class="d-block mb-3 text-muted">Unknown</span>
}
